import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import {
  dataabout,
  meta,
  worktimeline,
  skills,
} from "../../content_option";

export const About = () => {
  return (
    <HelmetProvider>
      <Container className="About-header">
        <Helmet>
          <meta charSet="utf-8" />
          <title> About | {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <Row className="mb-5 mt-3">
          <Col lg="8">
            <h1 className="display-4 mb-4">About me</h1>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lg="5">
            <h3 className="color_sec py-4">{dataabout.title}</h3>
          </Col>
          <Col lg="7" className="d-flex align-items-center">
            <div>
                <div>
                ● Data scientist with AI/ML and data analysis experience across multiple business domains.
                </div>
                <div>
                ● Strong knowledge of the Python and C/C++ ecosystems and tooling.
                </div>
                <div>
                ● Solid object-oriented design and development fundamentals.
                </div>
                <div>
                ● Team-oriented problem-solver who takes pride and ownership in their work.
                </div>
                <div>
                ● Highly adaptable, energetic, and able to independently resolve complex system-design problems.
                </div>
            </div>
          </Col>
        </Row>
        <Row className=" sec_sp">
          <Col lg="5">
            <h3 className="color_sec py-4">Experience</h3>
          </Col>
          <Col lg="7">
            <table className="table caption-top">
              <tbody>
                {worktimeline.map((data, i) => {
                  return (
                    <tr key={i}>
                      <th scope="row">{data.jobtitle}</th>
                      <td>{data.start}</td>
                      <td>{data.end}</td>
                    </tr> 
                  );
                })}
              </tbody>
            </table>
            <div>
            &#8226; Led development team (6 members) with Agile methodologies for over 5 months.
            </div>
            <div>
            &#8226; Architected sustainable, robust, and maintainable coding patterns for ResearchTube.
            </div>
            <div>
            &#8226; Guarantee code quilty with unit test, automation test, and upholding pull request requirements
            </div>
            <div>
            &#8226; Communicate, connect and coordinate team members from 3 different time zones.
            </div>
            <div>
            &#8226; Implemented user service upon Node.js and video template service upon MongoDB and Django.
            </div>
            <div>
            &#8226; Led containerization of all 7 major services with Docker and led production deployment of the system on AWS.
            </div>
            <div>
            &#8226; Designed and implemented a rendering task queue to handle simultaneous rendering requests from 15 users originally to at least 10,000 users.
            </div>
            <div>
            &#8226; Armed with an advanced transformer model for accurate text summarization.
            </div>
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lg="5">
            <h3 className="color_sec py-4">Skills</h3>
          </Col>
          <Col lg="7">
            {skills.map((data, i) => {
              return (
                <div key={i}>
                  <h3 className="progress-title">{data.name}</h3>
                  <div className="progress">
                    <div
                      className="progress-bar"
                      style={{
                        width: `${data.value}%`,
                      }}
                    >
                      <div className="progress-value">{data.value}%</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Col>
        </Row>
      </Container>
    </HelmetProvider>
  );
};
